import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localDate'
})
export class SmLocalDatePipe implements PipeTransform {

  transform(value: string): any {

    if (!value) {
      return '';
    }
    return new Date(value + '+0000');
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/pipes/sm-local-date.pipe.ts